export function setPkInSessionStorage(pk) {
  sessionStorage.setItem('pkNumber', pk);
}

export function getPkFromSessionStorage() {
  return sessionStorage.getItem('pkNumber');
}

export function checkPkInSessionStorage() {
  const pk = sessionStorage.getItem('pkNumber');
  return pk !== null && pk !== '';
}
